(ns frontend.ui.component.lp-portal.admin-create-link.view
  (:require
   [frontend.ui.component.lp-portal.admin-create-link.style :as style]
   [goog.string :as gstring]
   [reitit.frontend.easy :as reitit-e]
   [herb.core :refer [<class]]))

(defn admin-create-link
  [{:keys [route text] :as props}]
  [:a
   {:class (<class style/create-link)
    :href  (reitit-e/href route)}
   [:i.fa.fa-plus]
   [:div
    [:span
     {:class (<class style/create-link-desktop-prefix)}
     "Create a"
     (gstring/unescapeEntities "&nbsp;")]
    [:span
     {:class (<class style/item-type-text)}
     text]]])
